module.exports = __webpack_public_path__ + "img/course_import_temp.894be5a3.svg";